const doc = [({"en":({"js":({"merfoto":({"tenant_photo_products":({"add_to_basket_button":({"choose_photos_and_add_to_basket":"Choose photos and add to basket"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;